import React from 'react'
import { BusyButtonLink } from '@ztechapps/webui.button'

export const EditContextMenuItem = ({ onClick }) => {
  return <BusyButtonLink onClick={onClick} icon="pencil" title="Edit this template?" />
}
